import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { useAppSelector } from "../hooks";

export enum Sport {
  BASKETBALL = "Basketball",
  HOCKEY = "Hockey",
  SOCCER = "Soccer",
  NO_SPORT = "NO_SPORT",
}

export interface CourtOption {
  id: string;
  label: string;
}

export interface CourtView {
  id: string;
  viewBox: string;
  width: number;
  height: number;
  label: string;
}

export interface SportSlice {
  name: Sport;
  courtOptions?: CourtOption[];
  courtViews?: CourtView[];
}

const initialState: SportSlice = {
  name: Sport.NO_SPORT,
};

export const sportSlice = createSlice({
  name: "Sport",
  initialState,
  reducers: {
    setSport: (state, action: PayloadAction<Pick<SportSlice, "name">>) => {
      state.name = action.payload.name;
    },
    setCourtOptions: (state, action: PayloadAction<Pick<SportSlice, "courtOptions">>) => {
      state.courtOptions = action.payload.courtOptions;
    },
    setCourtViews: (state, action: PayloadAction<Pick<SportSlice, "courtViews">>) => {
      state.courtViews = action.payload.courtViews;
    },
  },
});

export const { setSport, setCourtOptions, setCourtViews } = sportSlice.actions;
export const sportSliceReducer = sportSlice.reducer;

export const useGetSport = () => {
  const { name: sport } = useAppSelector((state) => state.sport);

  return sport;
};
